import { render, staticRenderFns } from "./StudyRecordCourseSlidebar.vue?vue&type=template&id=0968ba93"
import script from "./StudyRecordCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./StudyRecordCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports